import React from "react";

/**
 * When set, ChoiceGrid renders a single matrix-level radiogroup (aria-owns) so NVDA reports
 * a consistent "n of m" across all custom role="radio" cells (the lead-cell role="group"
 * otherwise splits the first radio into its own implicit group).
 */
export type ChoiceGridMatrixRadioGroupBridgeValue = {
    ownsIds: string;
    questionLabelIds: string | undefined;
};

export const ChoiceGridMatrixRadioGroupBridgeContext =
    React.createContext<ChoiceGridMatrixRadioGroupBridgeValue | null>(null);

export function useChoiceGridMatrixRadioGroupBridge(): ChoiceGridMatrixRadioGroupBridgeValue | null {
    return React.useContext(ChoiceGridMatrixRadioGroupBridgeContext);
}
